// Attribution d'affiliation au 1er clic, fenêtre 60 jours. Indépendant du domaine.
const KEY = "pulse_ref";
const VID = "pulse_vid";
const WINDOW_MS = 60 * 24 * 60 * 60 * 1000; // 60 jours

function visitorId() {
  try {
    let v = localStorage.getItem(VID);
    if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(VID, v); }
    return v;
  } catch { return "anon"; }
}

function trackClick(code) {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/track-click`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ref: code, visitor_id: visitorId() }), keepalive: true,
    }).catch(() => {});
  } catch {}
}

export function captureRef() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (!ref) return;
    const code = ref.trim().toLowerCase();
    const existing = getStored();
    if (!existing) {
      localStorage.setItem(KEY, JSON.stringify({ ref: code, ts: Date.now() })); // 1er clic prioritaire
    }
    trackClick(code);
  } catch {}
}

function getStored() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { ref, ts } = JSON.parse(raw);
    if (!ref || Date.now() - ts > WINDOW_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return ref;
  } catch {
    return null;
  }
}

export function getRef() {
  return getStored();
}
